import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import PostAddIcon from "@mui/icons-material/PostAdd";
import Button from "../../components/Button";
import TableComponent from "../../components/TableComponent";
import {
  getAssociatePositionProcessStep,
  deleteAssociatePositionProcessStepById,
} from "../../api/associate-position-process-step";
import Confirm from "../../components/Confirm";

const AssociatePositionProcessStepTable = ({ match, history }) => {
  const { t } = useTranslation();
  const [associatePositionProcessStep, setAssociatePositionProcessStep] = useState(null);
  const [selectedPositionId, setSelectedPositionId] = useState(null);
  const [isDeleteModalShow, setIsDeleteModalShow] = useState(false);
  const [refresh, setRefresh] = useState(1);

  function showDeleteModal(positionId) {
    setSelectedPositionId(positionId);
    setIsDeleteModalShow(true);
  }

  async function confirmDeleteModal(isConfirmed) {
    if (isConfirmed) {
      await deleteAssociatePositionProcessStepById(selectedPositionId);
    }
    setIsDeleteModalShow(false);
    setRefresh(refresh * -1);
  }

  useEffect(() => {
    (async () => {
      const res = await getAssociatePositionProcessStep();

      setAssociatePositionProcessStep(res.sort((a, b) => a.positionId - b.positionId));
    })();
  }, [refresh]);

  return (
    <>
      <Typography variant="h4">{t("associate_process_step.position_title")}</Typography>
      {associatePositionProcessStep ? (
        <TableComponent
          TopComponent={
            <Button size="small" onClick={() => history.push(`/associate-position-process-step/add`)}>
              <PostAddIcon />
              {t("associate_process_step.add_action")}
            </Button>
          }
          search={["name"]}
          header={[{ title: t("positions") }, { title: t("course_tree.process_step") }, { title: t("actions") }]}
          items={associatePositionProcessStep}
          renderChildren={(ps) => (
            <TableRow key={ps.positionId}>
              <TableCell>
                {ps.positionId} - {ps.positionName}
              </TableCell>
              <TableCell>
                {ps.data.map((d) => (
                  <li key={`${ps.id}-${d.processStepId}`}>
                    {d.processStepId} - {d.processStepName}
                  </li>
                ))}
              </TableCell>
              <TableCell>
                <Button
                  icon={<EditIcon />}
                  onClick={() => history.push(`/associate-position-process-step/edit/${ps.positionId}`)}
                  title={t("associate_process_step.edit_position_action")}
                />
                <Button
                  icon={<DeleteForeverIcon />}
                  onClick={() => showDeleteModal(ps.positionId)}
                  title={t("associate_process_step.delete_position_action")}
                />
              </TableCell>
            </TableRow>
          )}
        />
      ) : null}

      {isDeleteModalShow && selectedPositionId ? (
        <Confirm title={t("associate_process_step.delete_position_action")} onConfirm={confirmDeleteModal}>
          <p>{t("associate_process_step.delete_position_confirm")}</p>
        </Confirm>
      ) : null}
    </>
  );
};

export default AssociatePositionProcessStepTable;
